import { useQuery } from 'react-query';

import {
  cachedGetSelectorData,
  cachedGetSelectorStringData,
} from 'machines/shared/utils/getSelectorDataCache';

function useGetSelectorData(editor: any) {
  return useQuery(
    ['getSelectorData', { editor }],
    () => cachedGetSelectorData({ editor }),
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}

function useGetSelectorStringData(editor: any) {
  return useQuery(
    ['getSelectorStringData', { editor }],
    () => cachedGetSelectorStringData({ editor }),
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}

export { useGetSelectorData, useGetSelectorStringData };
